module.exports = __webpack_public_path__ + "assets/img/banner1.dea8041a.png";